module.exports = __webpack_public_path__ + "img/d931d85.jpg";